import {
    GA_Push
} from "./GoogleAnalytics";
import {
    mobile
} from "./Agent";

var urlToShare = window.document.querySelector("meta[property='og:url']").content;
var textToShare = window.document.querySelector("meta[property='og:description']").content + " >> " + urlToShare;

const shareFacebook = () => {
    GA_Push("Share_Facebook", urlToShare);
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare), "_blank");
}

const shareTwitter = () => {
    GA_Push("Share_Twitter", urlToShare);
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(urlToShare), "_blank");
}

const shareWhatsapp = () => {
    GA_Push("Share_WhatsApp", urlToShare);
    if (mobile()) {
        window.open("whatsapp://send?text=" + encodeURIComponent(textToShare), "_parent");
    } else {
        window.open("https://web.whatsapp.com/send?phone=&text=" + encodeURIComponent(textToShare), "_blank");
    }
}

const openNegishut = () => {
    GA_Push("Accessibility", "Open_Accessibility_Clicked");
    window.document.getElementById('INDmenu-btn').click();
}

export {
    shareFacebook,
    shareTwitter,
    shareWhatsapp,
    openNegishut
}


// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js